import type { IconData } from '@stacksjs/iconify-core'

export const wifiFlat: IconData = {
  "body": "<g fill=\"#8fbffa\"><path d=\"M24 4.834c-8.916 0-16.073 3.095-21.458 7.313c-1.323 1.037-1.59 2.875-.777 4.297l1.363 2.386c1.103 1.93 3.658 2.32 5.417 1.074c4.146-2.939 9.433-5.308 15.454-5.308s11.309 2.37 15.455 5.308c1.758 1.246 4.313.856 5.416-1.074l1.364-2.386c.812-1.422.546-3.26-.777-4.297C40.07 7.93 32.915 4.834 23.999 4.834Z\"/><path d=\"M24 20.166c-5.505 0-9.32 1.525-12.5 3.933c-1.41 1.067-1.588 3.027-.646 4.44l1.335 2.003c1.036 1.555 3.165 1.744 4.654.823c1.866-1.154 4.342-2.143 7.157-2.143c2.814 0 5.29.989 7.156 2.143c1.49.92 3.618.732 4.654-.823l1.335-2.003c.942-1.413.764-3.373-.645-4.44c-3.181-2.408-6.996-3.933-12.5-3.933m-.04 14.238a4.881 4.881 0 0 0 .002 9.762a4.881 4.881 0 0 0-.002-9.762\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default wifiFlat
